export const colorCodes = ["#F8C52E", "#FA8E20", "#987CDD", "#16CBBC", "#E65010", "#A60060", "#ED323B", "#35A1FF", "#FA8E20", "#80D348"];
